 <mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Customers </mat-panel-title>
        <mat-panel-description>
          Shows customers where we have a profit share at.
          <mat-icon>account_circle</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-divider></mat-divider>

      <!--<ng-container toolbar>
        <button mat-button (click)="add()">Add stakeholder relation<mat-icon>add</mat-icon></button>
      </ng-container>-->

      <t4-data-table #tblStakeholderCustomers [allowExcel]="false" [rawData]="customerData" [allowFilter]="false" [allowPaging]="false" headline="" matSort matSortActive="Procentile" matSortDirection="desc" [autoGenerateColumns]="false">
        <ng-container matColumnDef="EditRelation">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 60px;">Edit</mat-header-cell>
          <mat-cell *matCellDef="let row" style="padding-left: 0px; max-width: 60px;">
            <button (click)="editRow(row)" color="primary" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Customer">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">Customer</mat-header-cell>
          <mat-cell *matCellDef="let row" style="text-align: center; min-width:150px; padding-left: 15px;">{{row.Customer.Name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="XalAccountNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">XalAccountNo</mat-header-cell>
          <mat-cell *matCellDef="let row" style="text-align: center; min-width:150px; padding-left: 15px;">{{row.Customer.XalAccountNo}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Procentile">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">Procentile</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container style="text-align: center; min-width:150px; padding-left: 15px;">{{ row.Percentile }}</ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="UpdatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">UpdatedAt</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container style="text-align: center; min-width:150px; padding-left: 15px;">
              {{ (row.UpdatedAt ? row.UpdatedAt : row.CreatedAt) | date: 'd MMM y' }}
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Delete">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Remove</mat-header-cell>
          <mat-cell *matCellDef="let row" style="padding-left: 15px; max-width: 110px;">
            <button color="primary" mat-icon-button (click)="deleteRelation(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

      </t4-data-table>

      <ng-container *ngIf="!edit">
        <mat-divider></mat-divider>
        <div class="row" style="gap: 1rem; align-items: center;">
          <form style="display:flex; gap:1rem; max-width:60%; width:100%;">
            <mat-form-field>
              <mat-label>Customer</mat-label>
              <input  matInput [readonly]="true" [(ngModel)]="inputValue" name="customer">
              <mat-icon  style="cursor:pointer;" (click)="add()" matSuffix>person_add</mat-icon>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Percentile</mat-label>
              <input matInput [(ngModel)]="inputPercentile" name="percentile">
            </mat-form-field>
          </form>
          <button mat-raised-button color="primary" (click)="saveRow()">Add to relation</button>
        </div>
      </ng-container>

      <ng-container *ngIf="edit">
        <mat-divider></mat-divider>
        <div class="row" style="gap: 1rem; align-items: center;">
          <form style="display:flex; gap:1rem; max-width:60%; width:100%;">
            <mat-form-field>
              <mat-label>Customer</mat-label>
              <input matInput disabled [(ngModel)]="inputValue" name="customer">
              <mat-icon style="cursor:pointer;" (click)="clear()" matSuffix>close</mat-icon>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Percentile</mat-label>
              <input matInput [(ngModel)]="inputPercentile" name="percentile">
            </mat-form-field>
          </form>
          <button mat-raised-button color="primary" (click)="saveRow()">Edit relation</button>
        </div>
      </ng-container>
      <mat-divider></mat-divider>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Stakeholders </mat-panel-title>
        <mat-panel-description>
          Shows the stakeholders which have a profit share here.
          <mat-icon>savings</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <t4-data-table #tblStakeholder [allowExcel]="false" [rawData]="stakeholderData" [allowFilter]="false" [allowPaging]="false" headline="" matSort matSortActive="Procentile" matSortDirection="desc" [autoGenerateColumns]="false">
        <ng-container matColumnDef="EditRelation">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 60px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="padding-left: 0px; max-width: 60px;">
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Customer">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">Customer</mat-header-cell>
          <mat-cell *matCellDef="let row" style="text-align: center; min-width:150px; padding-left: 15px;">{{row.Customer.Name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Procentile">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">Procentile</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container style="text-align: center; min-width:150px; padding-left: 15px;">{{ row.Percentile }}</ng-container>
          </mat-cell>
        </ng-container>
      </t4-data-table>
    </mat-expansion-panel>
</mat-accordion>
